var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.001,
    height: 11.378,
    viewBox: "0 0 13.001 11.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "\\uE813",
    d: "M11.73-9.775a3.213,3.213,0,0,0-1.549-.736,3.42,3.42,0,0,0-1.7.127,3.6,3.6,0,0,0-1.473.939L6.5-8.937l-.508-.508a3.6,3.6,0,0,0-1.473-.939,3.42,3.42,0,0,0-1.7-.127,3.213,3.213,0,0,0-1.549.736A3.431,3.431,0,0,0,.178-8.15,3.7,3.7,0,0,0,.089-6.208a3.518,3.518,0,0,0,.927,1.714L5.916.559a.8.8,0,0,0,1.168,0l4.9-5.078a3.369,3.369,0,0,0,.927-1.688,3.7,3.7,0,0,0-.089-1.942A3.431,3.431,0,0,0,11.73-9.775Z",
    transform: "translate(0.001 10.565)",
    fill: "#ff6d6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavOn);
export default __webpack_public_path__ + "static/media/icon-fav-on.1af8019091624bf609fbde6921129869.svg";
export { ForwardRef as ReactComponent };